<template>
  <div v-show="tableData.length > 0">
    <el-divider content-position="left">
      专家列表 (共
      <b><span v-text="tableData.length"></span></b>
      人,可参会
      <b><span v-text="attendCount"></span></b>
      )
    </el-divider>
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      fit
      stripe
      class="mt10"
    >
      <el-table-column
        prop="sortNum"
        label="序号"
        min-width="60"
        align="center"
      />
      <el-table-column prop="mavinName" label="姓名" min-width="130" />
      <el-table-column prop="safeIdCard" label="身份证" min-width="150" />
      <el-table-column label="性别/民族/年龄/专业技术职称" min-width="130">
        <template slot-scope="scope">
          {{ scope.row.sex }}、{{ scope.row.nation }}、{{ scope.row.age }}
          <div>
            {{ scope.row.appellation }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="工作单位" min-width="150" />
      <el-table-column label="人员行业分类/行政级别" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.industry }}、{{ scope.row.executLevel }}
        </template>
      </el-table-column>
      <el-table-column
        prop="speName"
        label="主要从事的专业方向（研究学科）"
        min-width="175"
      />
      <el-table-column prop="minorName" label="二级专业" min-width="100" />
      <el-table-column
        prop="attend"
        label="可参会"
        min-width="85"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <i class="el-icon-success" v-show="scope.row.attend"></i>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="80" align="center">
        <template slot-scope="scope">
          <el-button
            size="smalll"
            type="text"
            @click="handleView(scope.row.mavinEid)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { seledRands } from '@/api/position/gains/mavin.js';

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      keyword: ''
    };
  },
  computed: {
    attendCount() {
      return (
        this.tableData && this.tableData.filter(item => item.attend).length
      );
    }
  },
  props: {
    batchEid: {
      type: String
    }
  },
  methods: {
    handleView(mavinEid) {
      window.open(`/position/base/review/${mavinEid}`, 'handleView');
    },
    list() {
      this.loading = true;
      seledRands(this.$route.params.gainEid, this.batchEid).then(res => {
        this.tableData = res;
        this.loading = false;
      });
    }
  },
  created() {
    this.list();
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 10px;
}
.el-icon-success {
  color: green;
}
</style>
